export default __webpack_public_path__ + "static/media/8.3292fdeb.webp";